"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=hospital.dto.js.map